var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"zoom-image-wrapper popup-link",attrs:{"href":_vm.zoom,"data-fancybox":"gallery","data-caption":""}},[_c('img',{staticClass:"product-slider__slide-img",attrs:{"src":_vm.image,"data-zoom":_vm.zoom,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }